import { Component, OnInit, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'app-notification-block',
  templateUrl: './notification-block.component.html',
  styleUrls: ['./notification-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationBlockComponent implements OnInit {
  @Input()
  status: NotificationBlockStatus = NotificationBlockStatus.Warning;
  @Input()
  icon:boolean = true;
  @HostBinding("class")
  get statusClass(): string {
    switch (this.status) {
      case NotificationBlockStatus.Error:
        return "error";
      case NotificationBlockStatus.Information:
        return "info";
    }
    return "warning";
  }

  constructor() { }

  ngOnInit() {
  }
}

export enum NotificationBlockStatus {
  Warning,
  Information,
  Error
}